import { createAction } from 'redux-actions';
import * as types from '@src/store/types';

export const setSSRPage = createAction(types.SET_SSR_PAGE);
export const setDomain = createAction(types.SET_DOMAIN);
